<template>
<div class="banner-container">
     <Carousel v-bind="carouselConfig">
    <Slide v-for="(item,index) in items">
      <div class="carousel__item" @click="handleinfo(item.cid)">
        <img :src="getImagePath2(item.url)" alt="">
      </div>
    </Slide>
    <template #addons>
      <Navigation />
      <Pagination />
    </template>
  </Carousel>
</div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import 'vue3-carousel/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import banner1 from "@/assets/image/banner02.png"
import banner2 from "@/assets/image/banner03.png"
import banner3 from "@/assets/image/banner3.png"
// import banner4 from "@/assets/image/banner4.png"
import banner5 from "@/assets/image/banner5.png"
import banner6 from "@/assets/image/banner6.png"
import { useRouter } from "vue-router";
import {  getselectIndexBannerList }  from "@/api/index.js";
const router = useRouter();
const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};
const items = ref([
  { image: banner1, id: 'Image 1' },
  { image: banner2, id: 'Image 2' },
  { image: banner3, id: 'Image 3' },
  { image: banner6, id: 'zhyxid' },
//  { image: banner4, id: 'lhhid',cid:'4affb95f-ec8a-4c71-a3b2-f53ed4db5f03' },
  { image: banner5, id: 'zhyxid',cid:'c87fe5c1-ffc6-447e-aa35-484909d73b3a' },
])
const carouselConfig = {
  gap: 0,
  autoplay: 4000,
  wrapAround: true,
  pauseAutoplayOnHover: true,
  snapAlign:'center',
  wrapAround: true,
  itemsToShow:'auto',
}

const handleinfo = (id) =>{
  if(id){
   localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "newDatabaseInfo",
    query: { id: id },
  });
  }
 
}

onMounted(async()=>{
  const res = await getselectIndexBannerList({})
  items.value = res.info
  console.log(res,'lllll');
  
})

</script>
<style scoped>
.banner-container {
  position: relative;
  width: 100%;
  height: 380px;
  overflow: hidden;
}

.carousel__item {
  width: 1400px;
  margin: 0 auto;
  background: rgba(24, 24, 24, 0.8);
}

.carousel__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.5;
  cursor: pointer;
}
.carousel__slide--active{
  background: none;
}
.carousel__slide--active img{
  opacity: 1;
}

/* 导航按钮样式 - 默认隐藏 */
:deep(.carousel__prev),
:deep(.carousel__next) {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 100px;
  background-color: rgba(96, 96, 96, 0.8);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: none;
  outline: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

:deep(.carousel__prev) {
  left: calc(50% - 700px);
}

:deep(.carousel__next) {
  right: calc(50% - 700px); 
}

/* 鼠标悬停时显示箭头 */
.banner-container:hover :deep(.carousel__prev),
.banner-container:hover :deep(.carousel__next) {
  opacity: 1;
}

/* 悬停时箭头背景变化 */
:deep(.carousel__prev:hover),
:deep(.carousel__next:hover) {
  background-color: rgba(96, 96, 96, 1);
}

:deep(.carousel__pagination-button) {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  padding: 0;
}

:deep(.carousel__pagination-button--active) {
  background: white;
  transform: scale(1.2);
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .carousel__item {
    width: 100%;
  }
  
  :deep(.carousel__prev) {
    left: 20px;
  }
  
  :deep(.carousel__next) {
    right: 20px;
  }
}

@media (max-width: 768px) {
  .banner-container {
    height: 300px;
  }
  
  /* 在小屏幕上始终显示箭头 */
  :deep(.carousel__prev),
  :deep(.carousel__next) {
    opacity: 1;
  }
}
</style>